// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffportal/v1/user_model.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EclearOption, PhysicalContractDeliveryType } from "../../bfftypes/v1/contract_pb";
import { file_bfftypes_v1_contract } from "../../bfftypes/v1/contract_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffportal/v1/user_model.proto.
 */
export const file_bffportal_v1_user_model: GenFile = /*@__PURE__*/
  fileDesc("Ch1iZmZwb3J0YWwvdjEvdXNlcl9tb2RlbC5wcm90bxIMYmZmcG9ydGFsLnYxIrsCCgJNZRIQCghpc19hZG1pbhgBIAEoCBIdChVpc19sYXRlc3RfdGVybV9hZ3JlZWQYAiABKAgSGQoRb3JnYW5pemF0aW9uX25hbWUYAyABKAkSKwoIY29udHJhY3QYBCABKAsyGS5iZmZwb3J0YWwudjEuTWUuQ29udHJhY3QSFwoPb3JnYW5pemF0aW9uX2lkGAUgASgJEhEKCW1lbWJlcl9pZBgGIAEoCRIQCghsYW5ndWFnZRgHIAEoCRp+CghDb250cmFjdBJACg1kZWxpdmVyeV90eXBlGAEgASgOMikuYmZmdHlwZXMudjEuUGh5c2ljYWxDb250cmFjdERlbGl2ZXJ5VHlwZRIwCg1lY2xlYXJfb3B0aW9uGAIgASgOMhkuYmZmdHlwZXMudjEuRWNsZWFyT3B0aW9uQr8BChBjb20uYmZmcG9ydGFsLnYxQg5Vc2VyTW9kZWxQcm90b1ABWkpnaXRodWIuY29tL2VuZWNoYWluL2Vwb3NpdGlvbi1hcHAvYmFja2VuZC9nZW4vcHJvdG8vYmZmcG9ydGFsL3YxO2JmZnBvcnRhbKICA0JYWKoCDEJmZnBvcnRhbC5WMcoCDEJmZnBvcnRhbFxWMeICGEJmZnBvcnRhbFxWMVxHUEJNZXRhZGF0YeoCDUJmZnBvcnRhbDo6VjFiBnByb3RvMw", [file_bfftypes_v1_contract]);

/**
 * @generated from message bffportal.v1.Me
 */
export type Me = Message<"bffportal.v1.Me"> & {
  /**
   * @generated from field: bool is_admin = 1;
   */
  isAdmin: boolean;

  /**
   * @generated from field: bool is_latest_term_agreed = 2;
   */
  isLatestTermAgreed: boolean;

  /**
   * @generated from field: string organization_name = 3;
   */
  organizationName: string;

  /**
   * @generated from field: bffportal.v1.Me.Contract contract = 4;
   */
  contract?: Me_Contract;

  /**
   * @generated from field: string organization_id = 5;
   */
  organizationId: string;

  /**
   * @generated from field: string member_id = 6;
   */
  memberId: string;

  /**
   * Effective UI language (ja/en): the member's saved preference, or the
   * eLogin account language as the initial default.
   *
   * @generated from field: string language = 7;
   */
  language: string;
};

/**
 * Describes the message bffportal.v1.Me.
 * Use `create(MeSchema)` to create a new message.
 */
export const MeSchema: GenMessage<Me> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_user_model, 0);

/**
 * @generated from message bffportal.v1.Me.Contract
 */
export type Me_Contract = Message<"bffportal.v1.Me.Contract"> & {
  /**
   * @generated from field: bfftypes.v1.PhysicalContractDeliveryType delivery_type = 1;
   */
  deliveryType: PhysicalContractDeliveryType;

  /**
   * @generated from field: bfftypes.v1.EclearOption eclear_option = 2;
   */
  eclearOption: EclearOption;
};

/**
 * Describes the message bffportal.v1.Me.Contract.
 * Use `create(Me_ContractSchema)` to create a new message.
 */
export const Me_ContractSchema: GenMessage<Me_Contract> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_user_model, 0, 0);

